<div class="grid-container">
  <h1 class="mat-h1">Dashboard</h1>
  <!--<h2>Purchased licences</h2>
  <mat-table [dataSource]="userLicences$ | async">
    <ng-container matColumnDef="product">
      <mat-header-cell *matHeaderCellDef> Product </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.product}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="validSince">
      <mat-header-cell *matHeaderCellDef> Valid since </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.validSince.toDate() | date}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="validTill">
      <mat-header-cell *matHeaderCellDef> Valid till </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.validTill.toDate() | date}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="paymentStatus">
      <mat-header-cell *matHeaderCellDef> Payment status </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.payPalClientAuthorizedData || row.bankTransferInvoiceNumber ? 'paid' : 'unpaid'}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="['product', 'validSince', 'validTill', 'paymentStatus']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['product', 'validSince', 'validTill', 'paymentStatus']"></mat-row>
  </mat-table>
  &lt;!&ndash;<a mat-button routerLink="/order">Order new licence</a>&ndash;&gt;

  <h2>Operators</h2>
  <mat-table [dataSource]="operators$ | async">
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.email}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.status}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-stroked-button type="button" (click)="deleteOperator(row)">Delete operator</button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="['email', 'status', 'actions']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['email', 'status', 'actions']"></mat-row>
  </mat-table>
  <a mat-button (click)="createInvitation()">Invite new operator</a>-->
</div>
